<span *ngIf="activity.activityCollaborationOriginal.hasValue()" title="You added this activity as a collaboration">
  <span class="badge badge-info mx-2">Collaboration</span>
</span>